import { vaccineProductApi } from "api/immunization";
import MasterListScreen from "./common/MasterListScreen";
import VaccineProductModal from "./VaccineProductModal";

const antigenLabel = (item) => {
  const names = (item.composition || [])
    .map((entry) =>
      typeof entry.antigenId === "object" ?
        entry.antigenId?.antigenName
      : entry.antigenCode,
    )
    .filter(Boolean);
  return names.length ? names.join(", ") : "—";
};

const VaccineProductList = ({ searchText = "" }) => (
  <MasterListScreen
    resource={vaccineProductApi}
    label="Vaccine product"
    entityLabel="vaccine product"
    addLabel="Add Vaccine Product"
    tag="immunization-product"
    headers={[
      "Name",
      "Code",
      "Manufacturer",
      "Antigens",
      "Presentation",
      "Status",
      "Action",
    ]}
    keys={[
      "name",
      "code",
      "manufacturer",
      "antigenLabel",
      "presentationCode",
      "statusChip",
      "action",
    ]}
    displayName={(item) => item.brandName}
    mapRow={(item) => ({ antigenLabel: antigenLabel(item) })}
    Modal={VaccineProductModal}
    searchText={searchText}
  />
);

export default VaccineProductList;
